import TransformComponent from '../../Component/Transform';
import Renderable from '../../Component/Renderable';
import GameObject, { GameObjectEvent } from '../../GameObject/GameObject';
import Sprite from '../Sprite';
import Point from '../../Utility/Point';
import AnimationComponent from '../../Component/Animation';
import SpeechBubble from './SpeechBubble';
import Game from '../../Game';
import { StartAnimation } from '../../System/Animation/AnimationHelper';
import Interactable from '../../Component/Interactable';

export const DESTROY_TOOLBOX: string = 'destory_toolbox';

export default class Suitcase extends GameObject {
    private bubbleInterval: any = null;

    public onCreate(params: { x: number; y: number }): void {
        this.name = 'toolbox_map_component';

        this.addComponent<TransformComponent>(TransformComponent, params);
        this.addComponent<Renderable>(Renderable);

        // Add the base sprite.
        const baseSprite: Sprite = GameObject.Instantiate(Sprite, {
            texture: 'toolbox_map_component',
            anchor: new Point(0.5, 1),
        });
        baseSprite.addComponent(Interactable, {
            enabled: true,
            buttonMode: true,
        });
        this.addChild(baseSprite);

        baseSprite.addComponent(AnimationComponent, {
            playOnStart: true,
            clipName: 'SuitcaseIdle',
        });
        baseSprite.on(GameObjectEvent.SELECTED, this.onClick.bind(this));

        // Add the speech bubble.
        const speechBubble: SpeechBubble = GameObject.Instantiate(
            SpeechBubble,
            {
                x: 0,
                y: -80,
                text: Game.locale.getText('FindMe'),
                textStyle: Game.style.getStyle('suitcase.text'),
                name: 'bubble',
                visible: false,
            }
        );
        speechBubble.addComponent(AnimationComponent);
        this.addChild(speechBubble);
    }
    protected set showBubble(value: boolean) {
        if (this.bubbleInterval !== null) {
            Game.ticker.clearInterval(this.bubbleInterval);
            this.bubbleInterval = null;
        }
        const bubble: GameObject = this.find('bubble');

        if (!bubble) return;

        StartAnimation(bubble, 'Alpha', {
            startAlpha: Number(!value),
            endAlpha: Number(value),
            duration: 350,
        });
    }
    protected onClick(): void {
        this.showBubble = true;
        this.bubbleInterval = Game.ticker.setInterval(() => {
            this.showBubble = false;
        }, 5000);
    }
}
